import { LocalStorageKeys, SessionStorageKeys } from "utils/storageKeys";
import { logError } from "services/logging";
import { queryClient } from "app/global";
import { currentUserQuery } from "services/users";
import { User } from "services/users/model";
export { LocalStorageKeys, SessionStorageKeys } from "utils/storageKeys";

export function hydrateSessionStorage() {
  try {
    // When openning a new tab we hydrate session storage.
    // We pass data between tabs via local storage.
    const serializedSessionStorage = localStorage.getItem(
      LocalStorageKeys.sessionStorageSnapshot
    );
    if (!serializedSessionStorage) {
      return;
    }

    const savedState = JSON.parse(serializedSessionStorage);
    for (const [key, value] of Object.entries(savedState)) {
      sessionStorage.setItem(key, value as any);
    }

    localStorage.removeItem(LocalStorageKeys.sessionStorageSnapshot);
  } catch (error) {
    logError("Failed to hydrate session storage from local storage", error);
  }

  const serializedUser = sessionStorage.getItem(SessionStorageKeys.user);
  if (serializedUser) {
    const user = JSON.parse(serializedUser) as User;
    queryClient.setQueryData(currentUserQuery().queryKey, user);
  }
}
